module.exports = __webpack_public_path__ + "a6ff692d3e923e5db256446d449f78e2.MP3";